import url from './url'
const AppConsts= {
    userManagement:{
        defaultAdminUserName: 'admin'
    },
    localization:{
        defaultLocalizationSourceName: 'Altosandes'
    },
    authorization:{
        encrptedAuthTokenName: 'enc_auth_token'
    },
    setting: {
        shrink: true,
        confirmLeave: false,
        nroTabs: 9,
        timeout: 3000000,
        appName: 'Altos Andes',
    },
    appBaseUrl: "http://localhost:8080",
    remoteServiceBaseUrl: url

}
export default AppConsts